<panel width="450">
    @if (brands) {
        <form>
            <h1>{{ 'microsoft365.free-ms365.select-brand.headline' | translate }}</h1>
            <section>
                {{ 'microsoft365.free-ms365.select-brand.description' | translate:{ productName: productName } }}
            </section>
            <section>
                <custom-select [label]="'microsoft365.free-ms365.select-brand.label' | translate"
                    [placeholder]="'general.none' | translate"
                    [selectList]="brands"
                    [(value)]="selectedBrandId"
                    [required]="true"></custom-select>
            </section>
            <section>
                <button confirm (click)="saveChanges()" [label]="'general.select' | translate"></button>
                <button ghost (click)="close()" [ignoreValidation]="true" [label]="'general.cancel' | translate"></button>
            </section>
        </form>
    }
</panel>
